import type { ApiMagentoPurchaseType } from "@jti/magento-types/src/api/api-magento-consumables-matrix.types";

import type { ConsumableMatrixItem } from "@product-details/containers/ConsumablesProductDetailsContainer/ConsumablesProductDetailsContainer.types";

export const getMatrixItemByProperties = (
  matrixItems: ConsumableMatrixItem[],
  packagingFormatId: string,
  purchaseType: ApiMagentoPurchaseType,
  flavour: string | number | null | undefined,
  strengthRating: number
): ConsumableMatrixItem | undefined =>
  matrixItems.find((item) => {
    return (
      item.packagingFormatId === packagingFormatId &&
      item.purchaseType === purchaseType &&
      item.flavorDetails?.flavour === flavour &&
      item.strengthDetails?.rating === strengthRating
    );
  });
